import CategoryForm from './CategoryForm.js'
import styles from './style.css'
import {connect} from 'react-redux'
import {
  submitFormUpdate,
  submitFormCreate,
  submitFormCreateAllOutlets
} from 'actions/library/category'
import * as mpLibraryCategory from 'mixpanel/library/category'

class CategoryDetail extends React.Component {
  render () {
    return (
      <div className={styles.wrapper}>
        <CategoryForm onSubmit={this._onSubmit} />
      </div>
    )
  }

  _onSubmit = (values) => {
    const {dispatch, categories} = this.props
    if (values.action === 'save') {
      delete values.action
      if (values.id) {
        dispatch(submitFormUpdate(values.id, values, categories))
      } else {
        mpLibraryCategory.libraryCategoryCreate({category: values, allOutlet: false})
        dispatch(submitFormCreate(values, categories))
      }
    } else {
      delete values.action
      mpLibraryCategory.libraryCategoryCreate({category: values, allOutlet: true})
      dispatch(submitFormCreateAllOutlets(values, categories))
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

function mapStateToProps (state) {
  const {categories} = state.library.category
  return {
    categories
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryDetail)



// WEBPACK FOOTER //
// ./app/pages/Library/Category/CategoryDetail/CategoryDetail.js